import { render, staticRenderFns } from "./savedItems2.vue?vue&type=template&id=031fc164&scoped=true&"
import script from "./savedItems2.vue?vue&type=script&lang=js&"
export * from "./savedItems2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031fc164",
  null
  
)

export default component.exports